<rappider-list-grid [loading]="loading"
                    [config]="validatorsPatternConfig"
                    [data]="value"
                    (columnActionClick)="onColumnActionClick($event)"
                    (listActionClick)="openCreateValidatorsPatternModal()"></rappider-list-grid>
<rappider-modal [(visible)]="validatorsPatternModal.visible"
                [title]="validatorsPatternModal.title | translate"
                [okText]="'SHARED.SAVE' | translate"
                [cancelText]="'SHARED.CANCEL' | translate"
                width="60%"
                (okClick)="onValidatorsPatternModalSubmit()"
                (cancelClick)="closeValidatorsPatternModal()">
    <rappider-crud-view-edit-form *ngIf="validatorsPatternModal.visible"
                                    [config]="validatorsPatternFormConfig"
                                    [submitted]="validatorsPatternModal.isSubmitted"
                                    [data]="validatorsPatternModal.data"
                                    (validityChange)="onValidatorsPatternDataValidityChange($event)"
                                    (formValueChange)="onValidatorsPatternModalDataChange($event)"
                                    (fieldValueChange)="onValidatorsPatternFieldValueChange($event)"></rappider-crud-view-edit-form>
</rappider-modal>
